import React from 'react'
import Bills from "../../components/Bills/Bills"

const BillSection = () => {
    return (
       <Bills/>
    )
}

export default BillSection
